'use strict';

import * as dom from './lib/dom.js';


export default function(){
	window.addEventListener('DOMContentLoaded', function() {
        const openModalTrigger = document.querySelectorAll('.js-open-comment');
        const closeModalTrigger = document.querySelector('.js-close-comment');
        const modal = document.querySelector('.o-comment-modal');
		
        dom.forEachEl(openModalTrigger, (el) => {
            el.addEventListener('click', (e)=>{
                e.preventDefault();
                dom.addClass(modal, 'active');
            });
        });

		

        closeModalTrigger.addEventListener('click', (e)=>{
			e.preventDefault();
            dom.removeClass(modal, 'active');
		})
    });
}
